import { FC } from 'react'

import { Cluster, Grid, GridItem, Sheet, Skeleton, Stack, Typography } from '@forto-dev/phoenix-ui-core'
import { Layout, Shipment, Widget, WidgetFooter, WidgetHeader, WidgetTitle } from '@forto-dev/phoenix-ui-core/ship'

import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { Navigation } from '@/fragments/navigation'
import { WidgetSkeleton } from '@/fragments/widgetSkeleton'
import { useLocalisation } from '@/utils/localisation'

export const ShipmentsSkeleton: FC = () => {
  return (
    <Stack gap={24}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Stack key={index} gap={16}>
          <Grid col={5}>
            <Skeleton variant="content" fullWidth />
          </Grid>
          <ShipmentSkeleton key={index} />
        </Stack>
      ))}
    </Stack>
  )
}

const ShipmentSkeleton: FC = () => {
  return (
    <Sheet>
      <Shipment
        details={
          <Cluster gap={8}>
            <Skeleton variant="avatar" />
            <Stack gap={4}>
              <Skeleton variant="badge" />
              <Skeleton variant="content" fullWidth />
            </Stack>
          </Cluster>
        }
        reference={
          <Stack gap={4}>
            <Skeleton variant="content" />
            <Skeleton variant="content" fullWidth />
          </Stack>
        }
        status={<Skeleton variant="button" />}
        timeline={<Skeleton variant="button" fullWidth />}
        actions={<Skeleton variant="icon" />}
      />
    </Sheet>
  )
}

const ShipmentsHeaderSkeleton: FC = () => {
  return (
    <Cluster x="between">
      <Grid col={12} gap={8}>
        <GridItem span={5}>
          <Skeleton variant="button" fullWidth />
        </GridItem>
        <GridItem span={2}>
          <Skeleton variant="button" />
        </GridItem>
        <GridItem span={2}>
          <Skeleton variant="button" />
        </GridItem>
      </Grid>
      <Grid col={10} gap={8}>
        <GridItem span={6}>
          <Skeleton variant="button" fullWidth />
        </GridItem>
        <GridItem span={4}>
          <Skeleton variant="button" />
        </GridItem>
      </Grid>
    </Cluster>
  )
}

export const RequiredActionsSkeleton: FC = () => {
  return (
    <Widget variant="neutral">
      <WidgetHeader>
        <WidgetTitle>
          <Skeleton />
        </WidgetTitle>
      </WidgetHeader>
      <WidgetFooter>
        <Skeleton variant="card" />
      </WidgetFooter>
    </Widget>
  )
}

export const ShipmentsSidebarSkeleton: FC = () => {
  return (
    <Stack gap={16}>
      <RequiredActionsSkeleton />
      <WidgetSkeleton count={3} />
    </Stack>
  )
}

export const OverviewSkeleton: FC = () => {
  const { translate } = useLocalisation()
  return (
    <Layout
      header={<Header />}
      navigation={<Navigation />}
      title={
        <Cluster gap={8} y="baseline">
          <Typography variant="h4">{translate('navigation.overview')}</Typography>
        </Cluster>
      }
      sidebar={<ShipmentsSidebarSkeleton />}
      main={
        <Stack gap={24}>
          <ShipmentsHeaderSkeleton />
          <ShipmentsSkeleton />
        </Stack>
      }
      footer={<Footer />}
    />
  )
}
